(function(){
  var ROOT_SELECTOR = '[data-bk-cloud-portal-v4]';
  var STORAGE_KEY = 'bkCloudPortalV4State';

  function $(root, selector){
    return root.querySelector(selector);
  }

  function $all(root, selector){
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function safeParse(raw, fallback){
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch(e) {
      return fallback;
    }
  }

  function saveState(state){
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch(e) {}
  }

  function loadState(){
    var base = {
      mode: 'magic',
      lang: 'en',
      captions: true,
      sound: false,
      completed: [],
      rippleCount: 0,
      chimeCount: 0,
      scentPicks: [],
      artSlots: {},
      hiddenDoor: 'sleeping',
      stamp: false
    };

    var saved = safeParse(localStorage.getItem(STORAGE_KEY), {});
    Object.keys(saved || {}).forEach(function(key){
      base[key] = saved[key];
    });

    if(!Array.isArray(base.completed)) base.completed = [];
    if(!Array.isArray(base.scentPicks)) base.scentPicks = [];
    if(!base.artSlots || typeof base.artSlots !== 'object') base.artSlots = {};

    return base;
  }

  function t(value, lang){
    if(!value) return '';
    if(typeof value === 'string') return value;
    return value[lang] || value.en || '';
  }

  function hasCompleted(state, id){
    return state.completed.indexOf(id) >= 0;
  }

  function completeQuest(root, state, id){
    if(!id || hasCompleted(state, id)) return;

    state.completed.push(id);

    if(state.completed.length >= 4) {
      state.stamp = true;
      state.hiddenDoor = 'glowing';
    }

    if(state.completed.length >= 6) {
      state.hiddenDoor = 'opening';
    }

    saveState(state);
    renderProgress(root, state);
    burst(root);
    toast(root, 'Discovery unlocked');
  }

  function toast(root, message){
    var el = $(root, '[data-toast]');
    if(!el) return;

    el.textContent = message;
    el.classList.add('is-on');

    clearTimeout(el._timer);
    el._timer = setTimeout(function(){
      el.classList.remove('is-on');
    }, 2300);
  }

  function burst(root){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    for(var i = 0; i < 22; i++){
      var dot = document.createElement('span');
      dot.className = 'bkcp-burst';
      dot.style.left = (window.innerWidth / 2) + 'px';
      dot.style.top = (window.innerHeight / 2) + 'px';
      dot.style.setProperty('--dx', (Math.random() * 260 - 130) + 'px');
      dot.style.setProperty('--dy', (Math.random() * 220 - 140) + 'px');
      document.body.appendChild(dot);
      setTimeout(function(n){
        return function(){ n.remove(); };
      }(dot), 950);
    }
  }

  function makeParticle(x, y){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var dot = document.createElement('span');
    dot.className = 'bkcp-particle';
    dot.style.left = x + 'px';
    dot.style.top = y + 'px';
    document.body.appendChild(dot);

    setTimeout(function(){
      dot.remove();
    }, 900);
  }

  function vibrate(pattern){
    try {
      if(navigator.vibrate) navigator.vibrate(pattern || 30);
    } catch(e) {}
  }

  function playTone(root, high){
    var state = root._bkState;
    if(!state || !state.sound) return;

    try {
      var AudioContext = window.AudioContext || window.webkitAudioContext;
      if(!AudioContext) return;

      root._audio = root._audio || new AudioContext();

      var ctx = root._audio;
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();

      osc.type = 'sine';
      osc.frequency.value = high ? 760 : 420;

      gain.gain.setValueAtTime(0.0001, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.08, ctx.currentTime + 0.025);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.42);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start();
      osc.stop(ctx.currentTime + 0.45);
    } catch(e) {}
  }

  function applyMode(root, state){
    root.setAttribute('data-mode', state.mode || 'magic');
    root.setAttribute('data-captions', state.captions ? 'on' : 'off');

    $all(root, '[data-mode-btn]').forEach(function(btn){
      var on = btn.getAttribute('data-mode-btn') === state.mode;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
    });

    var langBtn = $(root, '[data-lang]');
    if(langBtn) langBtn.textContent = state.lang === 'ko' ? 'English' : '한국어';

    var ccBtn = $(root, '[data-cc]');
    if(ccBtn) ccBtn.textContent = state.captions ? 'CC On' : 'CC Off';

    var soundBtn = $(root, '[data-sound]');
    if(soundBtn) soundBtn.textContent = state.sound ? 'Sound On' : 'Mute';
  }

  function setVideoSource(video, src){
    if(!video || !src) return;
    if(video.getAttribute('src') === src) return;

    video.setAttribute('src', src);
    video.load();

    var play = video.play();
    if(play && play.catch) {
      play.catch(function(){});
    }
  }

  function renderCaption(root){
    var video = $(root, '[data-main-video]');
    var caption = $(root, '[data-caption]');
    var config = root._bkConfig;
    var state = root._bkState;

    if(!video || !caption || !config || !state) return;

    var lines = config.captions || [];
    var now = video.currentTime || 0;
    var found = '';

    for(var i = 0; i < lines.length; i++){
      if(now >= lines[i].start && now <= lines[i].end){
        found = t(lines[i].text, state.lang);
        break;
      }
    }

    caption.textContent = found;
  }

  function renderProgress(root, state){
    var total = 6;
    var found = Math.min(state.completed.length, total);
    var percent = Math.round((found / total) * 100);

    var count = $(root, '[data-progress-count]');
    if(count) count.textContent = found + ' / ' + total + ' discoveries';

    var bar = $(root, '[data-progress-bar]');
    if(bar) bar.style.setProperty('--p', percent + '%');

    $all(root, '[data-quest]').forEach(function(btn){
      var id = btn.getAttribute('data-quest');
      btn.classList.toggle('is-done', hasCompleted(state, id));
    });

    $all(root, '[data-hotspot]').forEach(function(btn){
      var id = btn.getAttribute('data-hotspot');
      btn.classList.toggle('is-done', hasCompleted(state, id));
    });

    var passport = $(root, '[data-passport-mini]');
    if(passport) {
      passport.classList.toggle('is-stamping', !!state.stamp);
      var text = $(passport, '[data-passport-status]');
      if(text) text.textContent = state.stamp ? 'Cloud Sensor Stamp unlocked' : 'Complete 4 discoveries to unlock the stamp';
    }

    var door = $(root, '[data-hidden-door]');
    if(door) {
      door.classList.remove('is-glowing', 'is-opening');
      if(state.hiddenDoor === 'glowing') door.classList.add('is-glowing');
      if(state.hiddenDoor === 'opening') door.classList.add('is-opening');
    }

    renderWall(root, state);
  }  function getVaultItems(){
    try {
      if(window.BKArtVault && window.BKArtVault.importLegacy) {
        window.BKArtVault.importLegacy();
      }

      if(window.BKArtVault && window.BKArtVault.read) {
        return window.BKArtVault.read();
      }
    } catch(e) {}

    return [];
  }

  function renderWall(root, state){
    var config = root._bkConfig || {};
    var frames = config.frames || [];
    var defaultFrame = frames[0] ? frames[0].url : '';

    $all(root, '[data-wall-slot]').forEach(function(slot){
      var slotId = slot.getAttribute('data-wall-slot');
      var placed = state.artSlots && state.artSlots[slotId];

      if(!placed || !placed.imageData) {
        slot.innerHTML = '<div class="bkcp-emptyframe">＋</div>';
        return;
      }

      var frameUrl = placed.frameUrl || defaultFrame;

      slot.innerHTML =
        '<div class="bkcp-frameart">' +
          '<img class="bkcp-art" src="' + placed.imageData + '" alt="Heartopedia artwork">' +
          (frameUrl ? '<img class="bkcp-frameimg" src="' + frameUrl + '" alt="" aria-hidden="true">' : '') +
        '</div>' +
        '<b>' + escapeHtml(placed.nameplate || placed.artistName || 'Heartopedia Artist') + '</b>';
    });
  }

  function escapeHtml(value){
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function openPanel(root, name){
    closePanels(root);

    var panel = $(root, '[data-panel="' + name + '"]');
    if(!panel) return;

    if(name === 'vault') {
      renderVault(root);
    }

    panel.classList.add('is-open');

    var close = $(panel, '.bkcp-x');
    if(close) {
      setTimeout(function(){
        try { close.focus(); } catch(e) {}
      }, 40);
    }
  }

  function closePanels(root){
    $all(root, '[data-panel]').forEach(function(panel){
      panel.classList.remove('is-open');
    });
  }

  function renderVault(root){
    var state = root._bkState;
    var config = root._bkConfig || {};
    var items = getVaultItems();
    var list = $(root, '[data-vault-list]');
    var frames = $(root, '[data-frame-list]');
    var slots = $(root, '[data-slot-list]');
    var placeBtn = $(root, '[data-place-art]');
    var nameplate = $(root, '[data-nameplate]');

    if(!state) return;

    root._selectedArt = root._selectedArt || null;
    root._selectedFrame = root._selectedFrame || ((config.frames && config.frames[0]) || null);
    root._selectedSlot = root._selectedSlot || '1';

    if(list) {
      if(!items.length) {
        list.innerHTML =
          '<div class="bkcp-empty">' +
            '<h3>No Heartopedia artwork found on this device yet.</h3>' +
            '<p>Create or finish a Heartopedia artwork first, then return to hang it in the Museum.</p>' +
            '<div class="bkcp-linkrow">' +
              '<a href="' + escapeHtml(config.links.braveTeenHub || '#') + '">Go to Brave Teen Hub</a>' +
              '<a href="' + escapeHtml(config.links.heartopediaMain || '#') + '">Go to Heartopedia Main Hub</a>' +
            '</div>' +
          '</div>';
      } else {
        list.innerHTML = items.map(function(item, index){
          var active = root._selectedArt && root._selectedArt.artId === item.artId;
          return '<button type="button" class="bkcp-artpick ' + (active ? 'is-on' : '') + '" data-art-index="' + index + '">' +
            '<img src="' + item.imageData + '" alt="Saved Heartopedia art">' +
            '<span>' + escapeHtml(item.title || 'Heartopedia Art') +
            '<em>' + escapeHtml(item.sourceHub || 'Heartopedia') + ' . ' + escapeHtml(item.feelingWord || 'Feeling') + '</em></span>' +
          '</button>';
        }).join('');
      }
    }

    if(frames) {
      var frameData = config.frames || [];
      frames.innerHTML = frameData.map(function(frame, index){
        var active = root._selectedFrame && root._selectedFrame.id === frame.id;
        return '<button type="button" class="bkcp-framepick ' + (active ? 'is-on' : '') + '" data-frame-index="' + index + '">' +
          '<img src="' + frame.url + '" alt="">' +
          '<span>' + escapeHtml(frame.name || 'Frame') + '</span>' +
        '</button>';
      }).join('');
    }

    if(slots) {
      var slotData = ['1','2','3','4'];
      slots.innerHTML = slotData.map(function(id){
        return '<button type="button" class="bkcp-slotpick ' + (root._selectedSlot === id ? 'is-on' : '') + '" data-slot-pick="' + id + '">' +
          '<span>Frame Slot ' + id + '</span>' +
        '</button>';
      }).join('');
    }

    if(placeBtn) {
      placeBtn.disabled = !root._selectedArt;
      placeBtn.style.opacity = root._selectedArt ? '1' : '.55';
    }

    if(nameplate && root._selectedArt && !nameplate.value) {
      nameplate.value = root._selectedArt.artistName || '';
    }

    $all(root, '[data-art-index]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var index = parseInt(btn.getAttribute('data-art-index'), 10);
        root._selectedArt = items[index] || null;
        renderVault(root);
      });
    });

    $all(root, '[data-frame-index]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var index = parseInt(btn.getAttribute('data-frame-index'), 10);
        root._selectedFrame = (config.frames || [])[index] || null;
        renderVault(root);
      });
    });

    $all(root, '[data-slot-pick]').forEach(function(btn){
      btn.addEventListener('click', function(){
        root._selectedSlot = btn.getAttribute('data-slot-pick') || '1';
        renderVault(root);
      });
    });
  }

  function placeSelectedArt(root){
    var state = root._bkState;
    var art = root._selectedArt;
    var frame = root._selectedFrame;
    var slot = root._selectedSlot || '1';
    var nameplate = $(root, '[data-nameplate]');
    var name = nameplate ? nameplate.value.trim() : '';

    if(!state || !art) {
      toast(root, 'Choose Heartopedia art first');
      return;
    }

    state.artSlots = state.artSlots || {};

    state.artSlots[slot] = {
      artId: art.artId,
      imageData: art.imageData,
      title: art.title,
      feelingWord: art.feelingWord,
      artistName: art.artistName,
      nameplate: name || art.artistName || 'Heartopedia Artist',
      frameId: frame ? frame.id : '',
      frameUrl: frame ? frame.url : '',
      placedAt: new Date().toISOString()
    };

    if(!hasCompleted(state, 'masterpiece')) {
      state.completed.push('masterpiece');
    }

    var filled = Object.keys(state.artSlots).length;

    if(filled >= 1 && state.hiddenDoor === 'sleeping') {
      state.hiddenDoor = 'glowing';
    }

    if(filled >= 4) {
      if(!hasCompleted(state, 'curator4')) state.completed.push('curator4');
      state.hiddenDoor = 'opening';
      state.stamp = true;
    }

    saveState(state);
    renderProgress(root, state);
    closePanels(root);
    burst(root);
    toast(root, filled >= 4 ? 'Cloud Curator Badge unlocked' : 'Your artwork entered the Museum');
  }

  function setupPanels(root){
    $all(root, '[data-open-panel]').forEach(function(btn){
      btn.addEventListener('click', function(){
        openPanel(root, btn.getAttribute('data-open-panel'));
      });
    });

    $all(root, '[data-close-panel]').forEach(function(btn){
      btn.addEventListener('click', function(){
        closePanels(root);
      });
    });

    $all(root, '[data-panel]').forEach(function(panel){
      panel.addEventListener('click', function(e){
        if(e.target === panel) closePanels(root);
      });
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') closePanels(root);
    });

    var place = $(root, '[data-place-art]');
    if(place) {
      place.addEventListener('click', function(){
        placeSelectedArt(root);
      });
    }
  }

  function setupControls(root){
    var state = root._bkState;

    $all(root, '[data-mode-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        state.mode = btn.getAttribute('data-mode-btn') || 'magic';
        saveState(state);
        applyMode(root, state);
        toast(root, 'Mode changed to ' + state.mode);
      });
    });

    var lang = $(root, '[data-lang]');
    if(lang) {
      lang.addEventListener('click', function(){
        state.lang = state.lang === 'ko' ? 'en' : 'ko';
        saveState(state);
        applyMode(root, state);
        renderCaption(root);
        toast(root, state.lang === 'ko' ? 'Korean draft on' : 'English on');
      });
    }

    var cc = $(root, '[data-cc]');
    if(cc) {
      cc.addEventListener('click', function(){
        state.captions = !state.captions;
        saveState(state);
        applyMode(root, state);
      });
    }

    var sound = $(root, '[data-sound]');
    if(sound) {
      sound.addEventListener('click', function(){
        state.sound = !state.sound;
        saveState(state);
        applyMode(root, state);
        playTone(root, true);
      });
    }

    var enter = $(root, '[data-enter-portal]');
    if(enter) {
      enter.addEventListener('click', function(){
        var world = $(root, '[data-world]');
        if(world) world.scrollIntoView({behavior: state.mode === 'calm' ? 'auto' : 'smooth', block: 'start'});
        playTone(root, true);
        vibrate(35);
      });
    }
  }  function setupScenes(root){
    var config = root._bkConfig || {};
    var state = root._bkState;
    var video = $(root, '[data-main-video]');
    var label = $(root, '[data-scene-label]');
    var scenes = config.scenes || [];

    if(video && scenes.length){
      setVideoSource(video, scenes[0].video);

      video.muted = !state.sound;
      video.playsInline = true;

      video.addEventListener('timeupdate', function(){
        renderCaption(root);
      });

      video.addEventListener('click', function(){
        try {
          if(video.paused) video.play();
          else video.pause();
        } catch(e) {}
      });
    }

    $all(root, '[data-scene]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-scene');
        var scene = scenes.filter(function(item){
          return item.id === id;
        })[0];

        if(!scene) return;

        if(video) setVideoSource(video, scene.video);
        if(label) label.textContent = t(scene.name, state.lang);

        $all(root, '[data-scene]').forEach(function(b){
          b.classList.toggle('is-on', b === btn);
        });

        playTone(root, true);
      });
    });
  }

  function setupHotspots(root){
    var state = root._bkState;

    $all(root, '[data-hotspot]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        var id = btn.getAttribute('data-hotspot');

        if(id === 'wakeGate') {
          completeQuest(root, state, 'wakeGate');
          playTone(root, true);
          vibrate(35);
          return;
        }

        if(id === 'ripple') {
          state.rippleCount = (state.rippleCount || 0) + 1;
          rippleAt(root, e.clientX, e.clientY);
          playTone(root, true);

          if(state.rippleCount >= 5) {
            completeQuest(root, state, 'ripple');
          } else {
            saveState(state);
            toast(root, 'Ripple ' + state.rippleCount + ' of 5');
          }

          return;
        }

        if(id === 'whisper') {
          openPanel(root, 'whisper');
          playTone(root, true);
          return;
        }

        if(id === 'trail') {
          var trail = $(root, '[data-trail]');
          if(trail) trail.classList.add('is-on');
          completeQuest(root, state, 'trail');
          return;
        }

        if(id === 'aura') {
          openPanel(root, 'scent');
          return;
        }

        if(id === 'chime') {
          state.chimeCount = (state.chimeCount || 0) + 1;
          playTone(root, state.chimeCount % 2 === 0);

          if(state.chimeCount >= 3) {
            completeQuest(root, state, 'chime');
          } else {
            saveState(state);
            toast(root, 'Air chime ' + state.chimeCount + ' of 3');
          }

          return;
        }

        if(id === 'water') {
          rippleAt(root, e.clientX, e.clientY);
          completeQuest(root, state, 'water');
          vibrate(45);
          return;
        }

        if(id === 'masterpiece') {
          openPanel(root, 'vault');
          return;
        }

        if(id === 'hiddenDoor') {
          if(state.hiddenDoor === 'opening' || state.hiddenDoor === 'glowing') {
            openPanel(root, 'hidden');
          } else {
            toast(root, 'The Hidden Sky Door is still sleeping.');
          }
        }
      });
    });

    $all(root, '[data-quest]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-quest');
        var target = $(root, '[data-hotspot="' + id + '"]');

        if(target) {
          target.scrollIntoView({behavior: state.mode === 'calm' ? 'auto' : 'smooth', block: 'center'});
          target.classList.add('is-pulsing');
          setTimeout(function(){
            target.classList.remove('is-pulsing');
          }, 1200);
        }
      });
    });

    $all(root, '[data-whisper-choice]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var reaction = btn.getAttribute('data-whisper-choice') || '';
        completeQuest(root, state, 'whisper');

        if(reaction === 'trail') {
          var trail = $(root, '[data-trail]');
          if(trail) trail.classList.add('is-on');
        }

        closePanels(root);
        toast(root, 'The cloud heard your wonder.');
      });
    });

    $all(root, '[data-scent]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var scent = btn.getAttribute('data-scent');

        if(state.scentPicks.indexOf(scent) < 0) {
          state.scentPicks.push(scent);
        }

        if(state.scentPicks.length > 2) {
          state.scentPicks = state.scentPicks.slice(-2);
        }

        $all(root, '[data-scent]').forEach(function(b){
          b.classList.toggle('is-on', state.scentPicks.indexOf(b.getAttribute('data-scent')) >= 0);
        });

        if(state.scentPicks.length >= 2) {
          completeQuest(root, state, 'aura');
          closePanels(root);
          toast(root, 'Your Cloud Aura is glowing.');
        } else {
          saveState(state);
          toast(root, 'Choose one more cloud note.');
        }
      });
    });
  }

  function rippleAt(root, x, y){
    var stage = $(root, '[data-stage]');
    if(!stage) return;

    var box = stage.getBoundingClientRect();
    var ripple = document.createElement('span');

    ripple.className = 'bkcp-ripple-pop';
    ripple.style.left = (x - box.left) + 'px';
    ripple.style.top = (y - box.top) + 'px';

    stage.appendChild(ripple);

    setTimeout(function(){
      ripple.remove();
    }, 950);
  }

  function setupPointerMagic(root){
    var stage = $(root, '[data-stage]');
    if(!stage) return;

    stage.addEventListener('pointermove', function(e){
      var box = stage.getBoundingClientRect();
      var x = ((e.clientX - box.left) / box.width) * 100;
      var y = ((e.clientY - box.top) / box.height) * 100;

      stage.style.setProperty('--mx', x + '%');
      stage.style.setProperty('--my', y + '%');

      if(Math.random() > .88) {
        makeParticle(e.clientX, e.clientY);
      }
    }, {passive:true});
  }

  function setupTranscript(root){
    var config = root._bkConfig || {};
    var state = root._bkState;

    function paint(){
      var transcript = $(root, '[data-transcript-copy]');
      if(!transcript) return;

      var lines = config.captions || [];
      transcript.innerHTML = lines.map(function(line){
        return '<p><b>' + formatTime(line.start) + '</b> ' + escapeHtml(t(line.text, state.lang)) + '</p>';
      }).join('');
    }

    root._paintTranscript = paint;
    paint();
  }

  function formatTime(sec){
    sec = Math.floor(sec || 0);
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  function defaultConfig(){
    return {
      links: {
        braveTeenHub: '/pages/bacci-kid-heartopedia-teen-hub',
        heartopediaMain: '/pages/bacci-kid-heartopedia-main-hub',
        kpotMainHub: '/pages/kpot-main-hub',
        museumMainHub: '/pages/bacci-kid-museum-portals'
      },
      scenes: [
        {
          id: 'cloud-question',
          name: {
            en: 'Cloud Question Bubble',
            ko: '구름 질문 버블'
          },
          video: 'https://cdn.shopify.com/videos/c/o/v/18d77ab3271941ae84f38bba714ef8af.mp4'
        },
        {
          id: 'arrival-blast',
          name: {
            en: 'Cloud Portal Arrival',
            ko: '구름 포털 도착'
          },
          video: 'https://cdn.shopify.com/videos/c/o/v/e2d76769332a4dfdbd51525d5957f1c5.mp4'
        },
        {
          id: 'gate-open',
          name: {
            en: 'Opening the Cloud Gate',
            ko: '구름 문 열기'
          },
          video: 'https://cdn.shopify.com/videos/c/o/v/2506bf232c5049a182193b6a6cd8402b.mp4'
        },
        {
          id: 'cloud-palace',
          name: {
            en: 'Floating Cloud Kingdom',
            ko: '떠 있는 구름 왕국'
          },
          video: 'https://cdn.shopify.com/videos/c/o/v/36e8c66d9c0a438d8616970bcc346cf7.mp4'
        }
      ],
      captions: [
        {
          start: 0,
          end: 5,
          text: {
            en: 'How does the light ripple like that?',
            ko: '빛이 어떻게 저렇게 물결처럼 반짝일까요?'
          }
        },
        {
          start: 5,
          end: 9,
          text: {
            en: "I've never seen anything like it.",
            ko: '이런 건 한 번도 본 적이 없어요.'
          }
        }
      ],
      frames: [
        {
          id: 'celestial-crown',
          name: 'Celestial Crown',
          url: 'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/01-celestial-crown-ultra-bling-frame-transparent_1.png?v=1781114715'
        },
        {
          id: 'royal-diamond',
          name: 'Royal Diamond Palace',
          url: 'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/02-royal-diamond-palace-ultra-bling-frame-transparent_1.png?v=1781114714'
        },
        {
          id: 'cosmic-amethyst',
          name: 'Cosmic Amethyst Royal',
          url: 'https://cdn.shopify.com/s/files/1/0500/7307/5871/files/06-cosmic-amethyst-royal-ultra-bling-frame-transparent__1.png?v=1781114715'
        }
      ]
    };
  }

  function initRoot(root){
    if(!root || root._bkCloudReady) return;

    root._bkCloudReady = true;
    root._bkConfig = window.BK_CLOUD_PORTAL_V4_CONFIG || defaultConfig();
    root._bkState = loadState();

    if(root._bkConfig.scenes && root._bkConfig.scenes[0]) {
      var label = $(root, '[data-scene-label]');
      if(label) label.textContent = t(root._bkConfig.scenes[0].name, root._bkState.lang);
    }

    applyMode(root, root._bkState);
    setupControls(root);
    setupScenes(root);
    setupHotspots(root);
    setupPanels(root);
    setupPointerMagic(root);
    setupTranscript(root);
    renderProgress(root, root._bkState);

    try {
      if(window.BKArtVault && window.BKArtVault.importLegacy) {
        window.BKArtVault.importLegacy();
      }
    } catch(e) {}
  }

  function init(){
    $all(document, ROOT_SELECTOR).forEach(initRoot);
  }

  window.BKCloudPortalV4 = {
    init: init,
    initRoot: initRoot,
    loadState: loadState,
    saveState: saveState
  };

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();/* ============================================================
   BACCI KID CLOUD PORTAL v4.1 JS PATCH
   Staged mystery unlocks, cleaner quest guidance, Wonderverse flow
============================================================ */
(function(){
  var ROOT_SELECTOR = '[data-bk-cloud-portal-v4]';
  var STORAGE_KEY = 'bkCloudPortalV4State';

  function safeParse(raw, fallback){
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch(e) {
      return fallback;
    }
  }

  function readState(){
    var state = safeParse(localStorage.getItem(STORAGE_KEY), {});
    state.completed = Array.isArray(state.completed) ? state.completed : [];
    state.artSlots = state.artSlots && typeof state.artSlots === 'object' ? state.artSlots : {};
    return state;
  }

  function has(state, id){
    return state.completed.indexOf(id) >= 0;
  }

  function artVaultHasItems(){
    try {
      if(window.BKArtVault && window.BKArtVault.read) {
        return window.BKArtVault.read().length > 0;
      }
    } catch(e) {}
    return false;
  }

  function setHotspot(root, id, visible, locked){
    var btn = root.querySelector('[data-hotspot="' + id + '"]');
    if(!btn) return;

    btn.style.display = visible ? '' : 'none';
    btn.disabled = !!locked;
    btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
    btn.classList.toggle('bkcp-v41-locked', !!locked);
  }

  function updateMission(root, state){
    var title = root.querySelector('.bkcp-card-v41 h2');
    var copy = root.querySelector('.bkcp-card-v41 p');

    if(!title || !copy) return;

    var count = state.completed.length;

    if(!has(state, 'wakeGate')) {
      title.textContent = 'Start Here: Wake the Living Gate';
      copy.textContent = 'Tap Wake the Gate first. The Floating Cloud Kingdom opens one discovery at a time.';
      return;
    }

    if(count < 2) {
      title.textContent = 'Follow the First Cloud Clues';
      copy.textContent = 'Now try Catch Ripple or Ask the Cloud. Each discovery wakes more of the portal.';
      return;
    }

    if(count < 4) {
      title.textContent = 'Collect Four Discoveries';
      copy.textContent = 'Trace light, ring chimes, touch portal water, or mix a Cloud Aura to unlock your passport stamp.';
      return;
    }

    if(!state.stamp) {
      title.textContent = 'Open Your Wonderverse Passport';
      copy.textContent = 'Your Cloud Sensor Stamp is ready. Open your passport and watch the Hidden Sky Door glow.';
      return;
    }

    title.textContent = 'Reveal the Hidden Sky Door';
    copy.textContent = 'The Cloud Portal is awake. Add Heartopedia art or open the Hidden Sky Door to preview what comes next.';
  }

  function updateStage(root){
    var state = readState();
    var count = state.completed.length;
    var hasArt = artVaultHasItems();
    var placedArtCount = Object.keys(state.artSlots || {}).length;

    setHotspot(root, 'wakeGate', true, false);

    setHotspot(root, 'ripple', has(state, 'wakeGate'), false);
    setHotspot(root, 'whisper', has(state, 'wakeGate'), false);

    var middleOpen = count >= 2 || has(state, 'ripple') || has(state, 'whisper');
    setHotspot(root, 'trail', middleOpen, false);
    setHotspot(root, 'aura', middleOpen, false);
    setHotspot(root, 'chime', middleOpen, false);
    setHotspot(root, 'water', middleOpen, false);

    setHotspot(root, 'hiddenDoor', count >= 4 || placedArtCount > 0, false);
    setHotspot(root, 'masterpiece', hasArt || placedArtCount > 0, false);

    updateMission(root, state);

    root.classList.toggle('bkcp-v41-passport-ready', count >= 4);
    root.classList.toggle('bkcp-v41-art-ready', hasArt || placedArtCount > 0);
    root.classList.toggle('bkcp-v41-hidden-door-ready', count >= 4 || placedArtCount > 0);
  }

  function addRefresh(root){
    root.addEventListener('click', function(){
      setTimeout(function(){
        updateStage(root);
      }, 120);

      setTimeout(function(){
        updateStage(root);
      }, 800);
    }, true);
  }

  function init(){
    document.querySelectorAll(ROOT_SELECTOR).forEach(function(root){
      if(root._bkV41Ready) return;
      root._bkV41Ready = true;

      updateStage(root);
      addRefresh(root);

      setInterval(function(){
        updateStage(root);
      }, 1500);
    });
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();/* ============================================================
   BACCI KID CLOUD PORTAL v4.2 POLISH PATCH
   Locked quest dock, 3D tilt, cursor sparkle, full Wonderverse flow
============================================================ */
(function(){
  var ROOT_SELECTOR = '[data-bk-cloud-portal-v4]';
  var STORAGE_KEY = 'bkCloudPortalV4State';

  function safeParse(raw, fallback){
    try { return raw ? JSON.parse(raw) : fallback; }
    catch(e){ return fallback; }
  }

  function readState(){
    var state = safeParse(localStorage.getItem(STORAGE_KEY), {});
    state.completed = Array.isArray(state.completed) ? state.completed : [];
    state.artSlots = state.artSlots && typeof state.artSlots === 'object' ? state.artSlots : {};
    return state;
  }

  function has(state, id){
    return state.completed.indexOf(id) >= 0;
  }

  function artVaultHasItems(){
    try {
      return !!(window.BKArtVault && window.BKArtVault.read && window.BKArtVault.read().length);
    } catch(e) {
      return false;
    }
  }

  function setQuest(root, id, visible, locked){
    var btn = root.querySelector('[data-quest="' + id + '"]');
    if(!btn) return;

    btn.style.display = visible ? '' : 'none';
    btn.disabled = !!locked;
    btn.classList.toggle('bkcp-v42-locked', !!locked);
    btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
  }

  function updateQuestDock(root){
    var state = readState();
    var count = state.completed.length;
    var placedArtCount = Object.keys(state.artSlots || {}).length;
    var hasArt = artVaultHasItems();

    setQuest(root, 'wakeGate', true, false);

    var afterGate = has(state, 'wakeGate');
    setQuest(root, 'ripple', afterGate, false);
    setQuest(root, 'whisper', afterGate, false);

    var middleOpen = count >= 2 || has(state, 'ripple') || has(state, 'whisper');
    setQuest(root, 'trail', middleOpen, false);
    setQuest(root, 'aura', middleOpen, false);
    setQuest(root, 'chime', middleOpen, false);
    setQuest(root, 'water', middleOpen, false);

    setQuest(root, 'masterpiece', hasArt || placedArtCount > 0, false);

    var hiddenBtn = root.querySelector('[data-hotspot="hiddenDoor"]');
    if(hiddenBtn) {
      hiddenBtn.style.display = (count >= 4 || placedArtCount > 0) ? '' : 'none';
    }
  }

  function setupTilt(root){
    var hero = root.querySelector('.bkcp-arrival-v41 .bkcp-arrival-copy');
    var stage = root.querySelector('[data-stage]');
    var gates = Array.prototype.slice.call(root.querySelectorAll('.bkcp-gate-card'));

    function applyTilt(el, e, xName, yName, max){
      if(!el) return;
      var mode = root.getAttribute('data-mode');
      if(mode === 'calm') return;

      var box = el.getBoundingClientRect();
      var x = (e.clientX - box.left) / box.width;
      var y = (e.clientY - box.top) / box.height;
      var ry = (x - .5) * max;
      var rx = (.5 - y) * max;

      el.style.setProperty(xName, rx.toFixed(2) + 'deg');
      el.style.setProperty(yName, ry.toFixed(2) + 'deg');

      if(el === hero) {
        el.style.setProperty('--heroX', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--heroY', (y * 100).toFixed(1) + '%');
      }

      if(el === stage) {
        el.style.setProperty('--stageTiltX', rx.toFixed(2) + 'deg');
        el.style.setProperty('--stageTiltY', ry.toFixed(2) + 'deg');
      }
    }

    function reset(el, xName, yName){
      if(!el) return;
      el.style.setProperty(xName, '0deg');
      el.style.setProperty(yName, '0deg');
      if(el === stage) {
        el.style.setProperty('--stageTiltX', '0deg');
        el.style.setProperty('--stageTiltY', '0deg');
      }
    }

    if(hero) {
      hero.addEventListener('pointermove', function(e){
        applyTilt(hero, e, '--bkTiltX', '--bkTiltY', 7);
      }, {passive:true});

      hero.addEventListener('pointerleave', function(){
        reset(hero, '--bkTiltX', '--bkTiltY');
      });
    }

    if(stage) {
      stage.addEventListener('pointermove', function(e){
        applyTilt(stage, e, '--stageTiltX', '--stageTiltY', 4);
      }, {passive:true});

      stage.addEventListener('pointerleave', function(){
        reset(stage, '--stageTiltX', '--stageTiltY');
      });
    }

    gates.forEach(function(card){
      card.addEventListener('pointermove', function(e){
        if(root.getAttribute('data-mode') === 'calm') return;

        var box = card.getBoundingClientRect();
        var x = (e.clientX - box.left) / box.width;
        var y = (e.clientY - box.top) / box.height;
        card.style.setProperty('--gateTiltY', ((x - .5) * 8).toFixed(2) + 'deg');
        card.style.setProperty('--gateTiltX', ((.5 - y) * 8).toFixed(2) + 'deg');
      }, {passive:true});

      card.addEventListener('pointerleave', function(){
        card.style.setProperty('--gateTiltY', '0deg');
        card.style.setProperty('--gateTiltX', '0deg');
      });
    });
  }

  function setupSparkles(root){
    var last = 0;

    root.addEventListener('pointermove', function(e){
      if(root.getAttribute('data-mode') === 'calm') return;
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var now = Date.now();
      if(now - last < 80) return;
      last = now;

      var spark = document.createElement('span');
      spark.className = 'bkcp-v42-spark';
      spark.style.left = e.clientX + 'px';
      spark.style.top = e.clientY + 'px';
      document.body.appendChild(spark);

      setTimeout(function(){
        spark.remove();
      }, 760);
    }, {passive:true});
  }

  function setupDeveloperReset(root){
    var clicks = 0;
    var timer = null;

    var label = root.querySelector('.bkcp-breadcrumb strong');
    if(!label) return;

    label.addEventListener('click', function(){
      clicks++;
      clearTimeout(timer);

      timer = setTimeout(function(){
        clicks = 0;
      }, 900);

      if(clicks >= 7) {
        clicks = 0;
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch(e) {}
        alert('Cloud Portal progress reset for testing.');
        window.location.reload();
      }
    });
  }

  function refresh(root){
    updateQuestDock(root);
  }

  function init(){
    document.querySelectorAll(ROOT_SELECTOR).forEach(function(root){
      if(root._bkV42Ready) return;
      root._bkV42Ready = true;

      refresh(root);
      setupTilt(root);
      setupSparkles(root);
      setupDeveloperReset(root);

      root.addEventListener('click', function(){
        setTimeout(function(){ refresh(root); }, 120);
        setTimeout(function(){ refresh(root); }, 900);
      }, true);

      setInterval(function(){
        refresh(root);
      }, 1600);
    });
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();